import React, { useMemo, useState } from "react";
import { useDebouncedApiEffect } from "../../hooks/useDebouncedApiEffect";
import { GetUnreadCouresNotificationCountCancelToken } from "../../services/DashBoardServices";
import { generateFetchDataPayload, getDigitClass, MAX_DASHBOARD_RETRY_ATTEMPTS, triggerExponentialBackoff } from "./util";


export default function UnreadMessagesBadge({
    filterIntake,
    filterLearningMethod,
    filterLecturer,
    filterSchool
}) {
    const [unreadMessages, setUnreadMessages] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [retryFetchCount, setRetryCount] = useState(0);
    const showLoader = unreadMessages === null || unreadMessages === undefined || isLoading;

    const fetchUnreadMessages = async ({ cancelToken }) => {
        if (retryFetchCount >= MAX_DASHBOARD_RETRY_ATTEMPTS) {
            console.log("UnreadMessagesBadge - Max retries reached, skipping fetch");
            return;
        }

        const data = generateFetchDataPayload({
            filterIntake,
            filterSchool,
            filterLearningMethod,
            filterLecturer
        });

        try {
            setIsLoading(true);
            const res = await GetUnreadCouresNotificationCountCancelToken(data, cancelToken);
            setUnreadMessages(res.data.allUnreadMessage);
            setIsLoading(false);
        } catch (error) {
            console.error(`UnreadMessagesBadge - Attempt ${retryFetchCount + 1} failed`, error);
            if (retryFetchCount < MAX_DASHBOARD_RETRY_ATTEMPTS - 1) {
                triggerExponentialBackoff(retryFetchCount, setRetryCount);
            } else {
                setRetryCount(MAX_DASHBOARD_RETRY_ATTEMPTS);
                setIsLoading(false);
            }
        }
    };

    useDebouncedApiEffect(fetchUnreadMessages, [
        filterIntake,
        filterLearningMethod,
        filterLecturer,
        filterSchool,
        retryFetchCount
    ]);

    const countClass = useMemo(() => getDigitClass(unreadMessages), [unreadMessages]);

    if (retryFetchCount === MAX_DASHBOARD_RETRY_ATTEMPTS && !isLoading) {
        // Best effort given, return nothing.
        return "";
    }

    if (showLoader) {
        return (
            <span className="dashboard-loading">
                <i className="fas fa-cog fa-spin"></i>
            </span>
        );
    }

    return (
        <span className="nav-fa-comments" title="You have unread messages">
            <small className={`notify-count ${countClass}`}>{unreadMessages}</small>
            <i className="fal fa-comments comments"></i>
        </span>
    );
}
